function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNormalPack2 = function SvgNormalPack2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("radialGradient", {
    id: "normal-pack2_svg__a",
    cx: 63.6,
    cy: 2584.9,
    r: 56.96,
    gradientTransform: "translate(0 -2522)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#fde030"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#f7c02b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f4a223"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.6 118.8c-27.9 0-58-17.5-58-55.9S35.7 7 63.6 7c15.5 0 29.8 5.1 40.4 14.4 11.5 10.2 17.6 24.6 17.6 41.5s-6.1 31.2-17.6 41.4c-10.6 9.3-25 14.5-40.4 14.5z",
    style: {
      fill: "url(#normal-pack2_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.49 29.67c5.33 8.6 8.11 18.84 8.11 30.23 0 16.9-6.1 31.2-17.6 41.4-10.6 9.3-25 14.5-40.4 14.5-18.06 0-37-7.35-48.18-22.94 10.76 17.66 31 25.94 50.18 25.94 15.4 0 29.8-5.2 40.4-14.5 11.5-10.2 17.6-24.5 17.6-41.4 0-12.74-3.47-24.06-10.11-33.23z",
    style: {
      fill: "#eb8f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 88H39a4 4 0 1 1 0-8h50a4 4 0 1 1 0 8zM44.67 45.94c-4.19 0-8 3.54-8 9.42s3.81 9.41 8 9.41c4.19 0 8-3.54 8-9.41s-3.81-9.42-8-9.42z",
    style: {
      fill: "#422b0d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.28 49.87a2.87 2.87 0 0 0-3.82 1.34 2.87 2.87 0 0 0 .6 3.3c1.42.68 3.13.08 3.82-1.34a2.87 2.87 0 0 0-.6-3.3z",
    style: {
      fill: "#896024"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 45.94c-4.19 0-8 3.54-8 9.42s3.81 9.41 8 9.41c4.19 0 8-3.54 8-9.41s-3.79-9.42-8-9.42z",
    style: {
      fill: "#422b0d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.63 49.87a2.87 2.87 0 0 0-3.82 1.34 2.87 2.87 0 0 0 .6 3.3c1.42.68 3.13.08 3.82-1.34a2.87 2.87 0 0 0-.6-3.3z",
    style: {
      fill: "#896024"
    }
  }));
};
export default SvgNormalPack2;